import React, {useState} from 'react';
import {useSelector} from 'react-redux';

import {COUNTRY} from 'front-onceforall-core/dist/utils/country';

import {getFirstDossierCountry, setFirstDossierCountry} from '../../utils/document';

import RegistrationMessage from '../globalDashboard/registrationMessage';

import OrganisationDashboardView from './OrganisationDashboardView';

const countries = [
  COUNTRY.FRANCE,
  COUNTRY.GERMANY,
  COUNTRY.ITALY
];

const store = React.createContext(countries[0]);
export const useDossierCountry = () => React.useContext(store);

function OrganisationDashboardContainer() {
  const organisation = useSelector(globalState => globalState.organisation);
  const [dossierCountry, setDossierCountry] = useState(organisation.country);
  const {Provider} = store;

  function handleDossierCountryChange(event) {
    const country = event.target.value;
    setDossierCountry(country);
    setFirstDossierCountry(country);
  }

  React.useEffect(() => {
    const value = getFirstDossierCountry(countries, organisation.country);
    handleDossierCountryChange({target: {value}});
  }, [organisation.country]);

  return (
    <Provider value={dossierCountry}>
      <OrganisationDashboardView
        countries={countries}
        onCountryChange={handleDossierCountryChange}
      />

      <RegistrationMessage/>
    </Provider>
  );
}

export default OrganisationDashboardContainer;
